type Props = {
  assetId: string;
  alt: string;
  priority?: boolean;
  height?: number;
  className?: string;
};

const captions: Record<string, string> = {
  "chiang-mai": "Chiang Mai old city — destination photograph, not a hotel room",
  "hang-dong": "Countryside west of Chiang Mai — destination photograph",
  "koh-samet": "Koh Samet shoreline — destination photograph, not a confirmed room view",
  bangkok: "Bangkok city — destination photograph",
  lock: "Thailand landscape",
  journey: "Thailand journey",
};

const crops: Record<string, string> = {
  "chiang-mai": "center 38%",
  "hang-dong": "center 45%",
  "koh-samet": "center 55%",
  bangkok: "center 40%",
  lock: "center 50%",
  journey: "center 42%",
};

export function Photo({ assetId, alt, priority, height = 220, className }: Props) {
  const src = `/images/${assetId}.jpg`;
  return (
    <img
      className={className}
      src={src}
      srcSet={`${src} 800w`}
      sizes="(max-width: 720px) 100vw, 720px"
      alt={alt || captions[assetId] || ""}
      width={800}
      height={height}
      style={{ objectPosition: crops[assetId] ?? "center" }}
      fetchPriority={priority ? "high" : undefined}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      onError={(event) => {
        event.currentTarget.style.display = "none";
        event.currentTarget.parentElement?.classList.add("photo-fallback");
      }}
    />
  );
}
